import * as Sentry from '@sentry/react';
import { useAuth0 } from '@auth0/auth0-react';
import { Spinner } from 'component-library';
import { useProfileV2 } from '#lib/Profile';
import { useTransactionId } from '../hooks/useTransactionId';

import { FirePartnerLogout } from './firePartnerLogout';
import InitConfigCat from './InitConfigCat';
import { FeatureFlagsProvider } from './ConfigCatFlags';

export * from './initSentry';
export * from './ConfigCatFlags';

type GovernanceProviderProps = {
  children: React.ReactNode;
  errorPage: React.ReactElement;
  authenticatedErrorPage: React.ReactElement;
  transactionId?: string;
};

export const GovernanceProvider = ({
  children,
  errorPage,
  authenticatedErrorPage,
}: GovernanceProviderProps) => {
  const transactionId = useTransactionId();

  const { isAuthenticated, isLoading } = useAuth0();
  const { basicProfile } = useProfileV2();

  if (basicProfile) {
    if (transactionId) {
      Sentry.getCurrentScope().setTag('transaction_id', transactionId);
    }

    Sentry.setUser({
      email: basicProfile.email,
      id: basicProfile.email,
    });
  }

  if (isLoading) {
    return <Spinner size="xlarge" />;
  }

  return (
    <Sentry.ErrorBoundary fallback={isAuthenticated ? authenticatedErrorPage : errorPage}>
      <FeatureFlagsProvider>
        <FirePartnerLogout />
        {isAuthenticated && <InitConfigCat />}
        {children}
      </FeatureFlagsProvider>
    </Sentry.ErrorBoundary>
  );
};
